// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"22809c34","232":"48228b32","237":"93b110e0","357":"b192d2e2","526":"bd63738b","753":"2b2a6b11","854":"a521f56f","872":"036be32b"}[chunkId] + ".chunk.js";
};